<template>
</template>

<script>
    export default {
        name: "thirdAccountBind",
        data() {
          return {
            default_nick_name: '无名氏', //默认昵称
            sex_man: '男', //性别男
            sex_female: 'f', //性别女
            operation_type:'',//qq操作类型
            user_id:'',//用户登录id
          }
        },
      mounted() {
        this.operation_type = localStorage.getItem("operation_type");
        this.user_id = window.sessionStorage.getItem("id");
        let thirdType = this.$route.query.thirdType;
        let code = this.$route.query.code;
        if (thirdType == "1"){
          this.wxLogin_call_back(code);
        }else if(thirdType == "2"){
          //qq登陆回调检查
          this.qqLogin_call_back();
        } else if(thirdType == "3"){
          if (WB2.checkLogin()){
            this.wb_login_call_back();
          } else {
            window.location.reload();
          }
        }
      },
      methods:{
        //第三方登陆
        thirdLogin: function(loginFlag,thirdLoginId,thirdLoginName,thirdHeadImgUrl,thirdSex) {
          this.$api.post("/login/login", {
            "userFlag": loginFlag,
            "thirdLoginId": thirdLoginId,
            "thirdLoginName": thirdLoginName,
            "thirdHeadImgUrl": thirdHeadImgUrl,
            "thirdSex": thirdSex
          }).then(
            (response) => {
              localStorage.setItem("loginInfo", JSON.stringify(response.data));
              window.close();
            }
          )
        },

        //第三方账号绑定
        thirdBind: function(bindFlag,userId,thirdLoginId) {
          this.$api.post("/personalCenter/bindingThirdPartyAccount", {
            "userId": userId,
            "accountType": bindFlag,
            "account": thirdLoginId
          }).then(
            (response) => {
              localStorage.removeItem("operation_type");
              let bindObj = {};
              this.$set(bindObj,"third_bind_success_flag",bindFlag);
              for (let key in response.data) {
                this.$set(bindObj,key,response.data[key])
              }
              localStorage.setItem("bindObj", JSON.stringify(bindObj));
              window.close();
            }
          )
        },

        //微信回调
        wxLogin_call_back:function(code){
          this.$api.get("/login/getWechatInfo", {
            "code": code
          }).then(
            (response) => {
              if (this.operation_type == 'bind'){
                this.thirdBind(1,this.user_id,response.data.unionid);
              } else {
                this.thirdLogin(1,response.data.unionid,response.data.nickname,response.data.headimgurl,response.data.sex);
              }
            }
          )
        },

        //qq登陆回调
        qqLogin_call_back:function(){
          if (QC.Login.check()){
            let qqOpenid = null;
            let nickname = this.default_nick_name;
            let figureurl = null;
            let gender = null;
            Promise.resolve().then(
              ()=>{
                return new Promise((resolve, reject) => {
                  QC.Login.getMe(function (openid, access_token) {
                    var paras = {};
                    qqOpenid = openid;
                    QC.api("get_user_info", paras)
                    //指定接口访问成功的接收函数，s为成功返回Response对象
                      .success(function (s) {
                        //成功回调，通过s.data获取OpenAPI的返回数据
                        nickname = s.data.nickname;
                        figureurl = s.data.figureurl;
                        if (this.sex_man == s.data.gender) {
                          gender = 1;
                        } else {
                          gender = 2;
                        }
                        alert("获取用户信息成功！当前用户昵称为：" + s.data.nickname);
                      })
                      //指定接口访问失败的接收函数，f为失败返回Response对象
                      .error(function (f) {
                        //失败回调
                        alert("获取用户信息失败！");
                        return;
                      })
                      //指定接口完成请求后的接收函数，c为完成请求返回Response对象
                      .complete(function (c) {
                        //完成请求回调
                        alert("获取用户信息完成！");
                      });
                    resolve();
                  });
                })
              }
            ).then(()=>{
              if (this.operation_type == 'bind'){
                this.thirdBind(2,this.user_id,qqOpenid);
              } else {
                this.thirdLogin(2,qqOpenid,nickname,figureurl,gender);
              }
              //qq退出登录
              QC.Login.signOut();
            })
          }
        },

        //微博登陆回调
        wb_login_call_back:function(){
          if(WB2.checkLogin()){
            var openid = null;
            var username = this.default_nick_name;
            var userHeadImg = null;
            var gender = null;
            Promise.resolve().then(
              ()=>{
                return new Promise((resolve, reject) => {
                  WB2.anyWhere(function (W) {
                    W.parseCMD('/account/get_uid.json', function (oResult, bStatus) {
                      if (bStatus) {
                        // console.log(oResult.uid);
                        W.parseCMD('/users/show.json', function (oResult2, bStatus) {//通过uid获取用户信息
                          if (bStatus) {
                            openid = oResult2.id;//获取用户openid
                            username = oResult2.name;//获取用户名
                            userHeadImg = oResult2.profile_image_url;//获取用户微博头像
                            gender = oResult2.gender;//性别
                            if (gender == this.sex_female){
                              gender = 2
                            } else {
                              gender = 1
                            }
                          }
                          resolve();
                        }, {uid: oResult.uid}, {method: 'get', cache_time: 30});
                      }
                    }, {}, {method: 'get', cache_time: 30});
                  });
                });
              }
            ).then(()=>{
              //微博退出登录
              WB2.logout(function() {
                //callback function
              });
              if (this.operation_type == 'bind'){
                this.thirdBind(3,this.user_id,openid);
              } else {
                this.thirdLogin(3,openid,username,userHeadImg,gender);
              }
            })
          }
        },
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/public/thirdAccountBind.vue